/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-react-exports.mjs
 * Source: react@19.2.4 (ESM entry)
 * Generated at: 2026-03-01T21:44:18.124Z
 */

export const EMBEDDED_REACT_19_VERSION = "19.2.4" as const;

export const EMBEDDED_REACT_19_NAMED_EXPORTS = [
  "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE",
  "__COMPILER_RUNTIME",
  "act",
  "Activity",
  "cache",
  "cacheSignal",
  "captureOwnerStack",
  "Children",
  "cloneElement",
  "Component",
  "createContext",
  "createElement",
  "createRef",
  "forwardRef",
  "Fragment",
  "isValidElement",
  "lazy",
  "memo",
  "Profiler",
  "PureComponent",
  "startTransition",
  "StrictMode",
  "Suspense",
  "unstable_useCacheRefresh",
  "use",
  "useActionState",
  "useCallback",
  "useContext",
  "useDebugValue",
  "useDeferredValue",
  "useEffect",
  "useEffectEvent",
  "useId",
  "useImperativeHandle",
  "useInsertionEffect",
  "useLayoutEffect",
  "useMemo",
  "useOptimistic",
  "useReducer",
  "useRef",
  "useState",
  "useSyncExternalStore",
  "useTransition",
  "version"
] as const;
